var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHk(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 513,
    height: 343,
    viewBox: "0 0 513 343",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_301_1055)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0.959961H513V342.96H0V0.959961Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.2 120.76C269.1 141.86 260.1 137.86 255.7 156.26C229.6 149.96 213.6 123.76 219.8 97.6599C226.1 71.5599 252.3 55.5599 278.3 61.7599C269.6 98.6599 278.8 101.86 274.2 120.76ZM206.6 136.36C225.1 147.66 218.5 155.06 234.6 164.96C220.6 187.86 190.7 194.96 167.8 180.96C144.9 166.96 137.8 137.06 151.8 114.16C184.1 133.96 190 126.26 206.6 136.36ZM200.6 205.56C217.1 191.46 222 200.06 236.4 187.76C253.8 208.16 251.4 238.76 231 256.16C210.6 273.56 180 271.16 162.6 250.76C191.3 226.16 185.8 218.16 200.6 205.56ZM264.5 232.66C256.2 212.56 265.9 210.56 258.6 193.06C283.4 182.76 311.8 194.56 322 219.36C332.3 244.16 320.5 272.56 295.7 282.76C281.2 247.76 271.9 250.56 264.5 232.66ZM310 180.26C288.4 181.96 289.4 172.16 270.5 173.66C268.4 146.96 288.4 123.56 315.1 121.46C341.8 119.36 365.2 139.36 367.3 166.06C329.6 168.96 329.4 178.76 310 180.26Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_301_1055"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 513,
    height: 342,
    fill: "white",
    transform: "translate(0 0.959961)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHk);
export default __webpack_public_path__ + "static/media/HK.72f17a3c277025c8884c699a104eea3a.svg";
export { ForwardRef as ReactComponent };